// start:ng42.barrel
export * from './front-desk.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/front-desk/index.ts